// extracted by mini-css-extract-plugin
module.exports = {"container":"_33974c2b58--container--zIkHx","image":"_33974c2b58--image--g9dJd","description":"_33974c2b58--description--pRDiT","two-rows":"_33974c2b58--two-rows--Tw349"};